import { atom, Provider, useAtomValue, useSetAtom } from 'jotai';
const generatingIndexesAtom = atom<number[]>([]);
const isGeneratingBulkAtom = atom<boolean>(false);
export const useSetAiGenerateSubjectiveStatus = () => {
  const setGeneratingIndexes = useSetAtom(generatingIndexesAtom);
  const setIsGeneratingBulk = useSetAtom(isGeneratingBulkAtom);
  const addIndex = (index: number) => {
    setGeneratingIndexes(prev => [...prev, index]);
  };
  const removeIndex = (index: number) => {
    setGeneratingIndexes(prev => prev.filter(i => i !== index));
  };
  return {
    addIndex,
    removeIndex,
    setIsGeneratingBulk
  };
};
export const useAiGenerateSubjectiveStatusValue = () => {
  const generatingIndexes = useAtomValue(generatingIndexesAtom);
  const isGeneratingBulk = useAtomValue(isGeneratingBulkAtom);
  return {
    generatingIndexes,
    isGeneratingBulk
  };
};
export const AiGenerateSubjectiveStatusProvider = ({
  children
}: {
  children: React.ReactNode;
}) => {
  return <Provider data-sentry-element="Provider" data-sentry-component="AiGenerateSubjectiveStatusProvider" data-sentry-source-file="useAiGeneateSubjectiveStatus.tsx">{children}</Provider>;
};